import React, { useState, useEffect, useCallback, useRef } from 'react';
import 'gridjs/dist/theme/mermaid.css';
import { render } from 'react-dom';
import axios from '../../axios';
import { Col, Row } from 'react-bootstrap';
import {
  ahead_step_img,
  main_step_img,
  contract_step,
  contract_step_icon,
  file_icon,
} from '../../Const';

const ProjectListApplicant: React.FC = () => {
  const [projects, setProjects] = useState([]);
  const [process_description_header, setProcessDescriptionHeader] = useState('');
  const [process_description_footer, setProcessDescriptionFooter] = useState('');

  useEffect(() => {
    const getProject = async () => {
      try {
        const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/applicant/api/projects`);
        setProjects(response.data.subscriptions);
        setProcessDescriptionHeader(response.data.process_description_header);
        setProcessDescriptionFooter(response.data.process_description_footer);
      } catch (error) {
        console.error(error.message);
      }
    };
    getProject();
  }, []);
  const images = [
    {
      src: ahead_step_img,
    },
    {
      src: main_step_img,
    },
    {
      src: contract_step,
    },
  ];
  const stepImageList: JSX.Element[] = [];
  images.map(image => {
    stepImageList.push(
      <div className="col-lg mt-5">
        <img src={image.src} className="img-fluid" />
      </div>
    );
  });

  const projectsList: JSX.Element[] = [];
  projects.map((project: { [key: string]: string }, index) => {
    projectsList.push(
      <tr>
        <td className="id">
          <span className="no">No.{index + 1}</span>
          <span className="id-body">
            <a href="#">{project.id}</a>
          </span>
        </td>
        <td className="store">{project.store}</td>
        <td className="status">{project.status}</td>
        <td className="borrowing-date">{project.borrowingDate}</td>
        <td className="item">{project.item}</td>
        <td className="item-type">{project.itemType}</td>
        <td className="borrowing-amount">{project.borrowingAmount}</td>
        <td className="judge-result">{project.judgeResult}</td>
        <td className="warranty-number">{project.warrantyNumber}</td>
        <td className="contract-method">{project.contractMethod}</td>
      </tr>
    );
  });

  return (
    <div className="l-main">
      <div className="ml-3" dangerouslySetInnerHTML={{ __html: process_description_header }} />
      <div>
        {/* お手続きの流れ画像を表示 */}
        <div className="row my-3">{stepImageList}</div>

        <div className="row my-3">
          <div
            className="col-xl-8 col-lg-8 col-md-8"
            dangerouslySetInnerHTML={{ __html: process_description_footer }}
          />
          <div className="col-xl-4 col-lg-4 col-md-4 my-5">
            <div className="d-flex">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <img src={contract_step_icon} className="img-fluid" />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <img src={file_icon} className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="project-list">
        <table>
          <thead>
            <tr>
              <th>案件番号</th>
              <th>取扱店舗</th>
              <th>ステータス</th>
              <th>借入希望日</th>
              <th>ローン商品</th>
              <th>商品タイプ</th>
              <th>借入希望金額</th>
              <th>審査結果</th>
              <th>保証番号</th>
              <th>契約方法</th>
            </tr>
          </thead>
          <tbody>
            {projectsList.length === 0 ? (
              <tr>
                <td rowSpan={10}></td>
              </tr>
            ) : (
              projectsList
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

if (document.getElementById('project-list-applicant')) {
  render(<ProjectListApplicant />, document.getElementById('project-list-applicant'));
}
